export enum TravelTimeTab {
    travelTime = 'TRAVEL_TIME',
    velocity = 'VELOCITY',
}

export interface State {
    currentTab: TravelTimeTab | null;
    tabTimestamp: number;
}
